import axios from 'axios'

import store from '@/stores'

const URL = 'https://viacep.com.br/ws/' // eslint-disable-line

class CepServico {
  cep(cep) {
    store.setCarregando()
    return axios
      .get(`${URL}/${cep}/json`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return { err }
      })
  }
}

export default CepServico
